import { Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { isShowingTrial } from '@src/selectors/user';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const Trial = () => {
  const showTrial = useSelector(isShowingTrial);

  return (
    <>
      {showTrial && (
        <Box mt={1} mb={1}>
          <Box width="100%">
            <Alert
              icon={false}
              variant="filled"
              severity="warning"
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <FormattedMessage
                id="HeaderMenu.trial.message"
                values={{
                  link: (
                    <Link
                      color="inherit"
                      to="/admin/subscription"
                      className="SubscribeLink"
                    >
                      <FormattedMessage id="HeaderMenu.trial.linkText" />
                    </Link>
                  ),
                }}
              />
            </Alert>
          </Box>
        </Box>
      )}
    </>
  );
};

export default Trial;
